module.exports = __webpack_public_path__ + "img/cake-8.22b31f05.svg";